import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./navigation/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import useAuth from "@hooks/useAuth";
import { useAppSelector } from "@store/hooks";

//import all pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Employees from "@pages/Employees";
import AddProject from "@pages/AddProject";
import EditProject from "@pages/EditProject";
import EditProjectTexts from "@pages/EditProjectsTexts";
import PickEmployee from "@pages/PickEmployee";
import AddEmployee from "@pages/AddEmployee";
import EditEmployee from "@pages/EditEmployee";
import ProjectsOverview from "@pages/ProjectsOverview";
import LoadingZones from "@pages/LoadingZones";
import ArchivZones from "@pages/Archiv";



const App: React.FC = () => {
  const { checkUserPresence } = useAuth();
  const isAuthenticated = useAppSelector((state) => state.auth);

  useEffect(() => {
    checkUserPresence();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Router>
        {isAuthenticated ? (
          <Routes>
            <Route path="/" element={ <ProtectedRoute><Home /></ProtectedRoute> } />
            <Route path="/mitarbeiter" element={ <ProtectedRoute><Employees /></ProtectedRoute> } />
            <Route path="/neue-projekt" element={ <ProtectedRoute><AddProject /></ProtectedRoute> } />
            <Route path="/projekt-bearbeiten/:projectId" element={ <ProtectedRoute><EditProject /></ProtectedRoute> } />
            <Route path="/projekt-texte/:projectId" element={ <ProtectedRoute><EditProjectTexts /></ProtectedRoute> } />
            <Route path="/pick-mitarbeiter/:projectId" element={ <ProtectedRoute><PickEmployee /></ProtectedRoute> } />
            <Route path="/add-mitarbeiter" element={ <ProtectedRoute><AddEmployee /></ProtectedRoute> } />
            <Route path="/edit-mitarbeiter/:employeeId" element={ <ProtectedRoute><EditEmployee /></ProtectedRoute> } />
            <Route path="/projekte-ubersicht" element={ <ProtectedRoute><ProjectsOverview /></ProtectedRoute> } />
            <Route path="/ladezone-belegung" element={ <ProtectedRoute><LoadingZones /></ProtectedRoute> } />
            <Route path="/archiv" element={ <ProtectedRoute><ArchivZones /></ProtectedRoute> } />
          </Routes>
        ):(
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Login />} />
          </Routes>
        )}
    </Router>
  )
};

export default App;
